import { buildSummarizeLinks } from '@/features/blog/summarize'

export function SummarizeWith({
  title,
  articleUrl,
  promptPrefix,
}: {
  title: string
  articleUrl: string
  promptPrefix: string
}) {
  const links = buildSummarizeLinks(articleUrl, promptPrefix)
  return (
    <div>
      <p className="font-serif text-base font-semibold text-primary">{title}</p>
      <div className="mt-3 grid grid-cols-2 gap-2">
        {links.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-11 items-center gap-2 rounded-xl border border-border bg-background px-3 py-2 text-sm font-medium text-primary transition-colors hover:bg-muted sm:min-h-0"
          >
            <img
              src={link.icon}
              alt=""
              aria-hidden
              loading="lazy"
              className="size-4 shrink-0 rounded-full object-contain"
            />
            <span className="truncate">{link.name}</span>
          </a>
        ))}
      </div>
    </div>
  )
}
